import SignupErrorPage from './SignupErrorPage'
export default SignupErrorPage
